export default __webpack_public_path__ + "static/media/Compress-Biryani-by-Kilo-login.d61f3d60.jpg";